import { config } from '../config';

export function PrivacyPage(): JSX.Element {
  return (
    <div className="max-w-3xl space-y-6">
      <div>
        <h1 className="text-2xl font-semibold text-white">Privacy Policy</h1>
        <p className="text-sm text-gray-500 mt-1">Last updated: 2026</p>
      </div>

      <section className="space-y-2">
        <h2 className="text-lg font-semibold text-white">What we collect</h2>
        <ul className="list-disc ml-6 text-gray-300 text-sm space-y-1">
          <li>Your email address.</li>
          <li>Your property address.</li>
          <li>Issue title, description, and any attachments you upload.</li>
          <li>Comments you post on your service requests.</li>
        </ul>
      </section>

      <section className="space-y-2">
        <h2 className="text-lg font-semibold text-white">Why we collect it</h2>
        <p className="text-sm text-gray-300">
          We use this information solely to manage and resolve service requests for the property
          associated with your account.
        </p>
      </section>

      <section className="space-y-2">
        <h2 className="text-lg font-semibold text-white">Data sharing</h2>
        <p className="text-sm text-gray-300">
          Issue details (including attachments and comments) may be shared with contractors engaged
          to resolve the issue. We do not sell your data and we do not share it for marketing
          purposes.
        </p>
      </section>

      <section className="space-y-2">
        <h2 className="text-lg font-semibold text-white">Storage and security</h2>
        <p className="text-sm text-gray-300">
          Data is hosted on AWS in Australia. We take reasonable steps to protect personal
          information from misuse, interference, and loss, including secure hosting, encryption in
          transit, and access controls. We only collect limited personal information (email and
          property address) necessary to manage service requests.
        </p>
      </section>

      <section className="space-y-2">
        <h2 className="text-lg font-semibold text-white">Your rights</h2>
        <p className="text-sm text-gray-300">
          You may request access to, correction of, or deletion of your personal information by
          contacting us at{' '}
          <a className="text-red-400 hover:text-red-300 underline" href={`mailto:${config.supportEmail}`}>
            {config.supportEmail}
          </a>
          .
        </p>
      </section>

      <section className="space-y-2">
        <h2 className="text-lg font-semibold text-white">Contact</h2>
        <p className="text-sm text-gray-300">
          For privacy-related questions or complaints, email{' '}
          <a className="text-red-400 hover:text-red-300 underline" href={`mailto:${config.supportEmail}`}>
            {config.supportEmail}
          </a>
          .
        </p>
      </section>
    </div>
  );
}
